"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = knocks;
var _types = require("../../actions/knock/types");
var _underscore = require("underscore");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function isSameKnockId(payload) {
  return function (kn) {
    return kn._id !== payload._id;
  };
}
function knocks() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var action = arguments.length > 1 ? arguments[1] : undefined;
  if (action.type === "".concat(_types.BROADCAST_RECEIVE_KNOCK)) {
    // Legacy support
    if (state.filter(function (kn) {
      return kn.socketId === action.payload.socketId;
    }).length) return state;
    // Add to array if its a new knock
    return [].concat(_toConsumableArray(state), [action.payload]);
  }

  //NOTE: in the future, simply removing the rejected user from knocks will probably not be sufficient, because the person "knocking"
  //will just be able to request access again and again, not matter if they've been rejected (probably need to keep track of
  //rejected knocks in a separate reducer)
  if (action.type === "".concat(_types.BROADCAST_ACCEPT_KNOCK) || action.type === "".concat(_types.BROADCAST_REJECT_KNOCK)) {
    return state.map(function (knock) {
      if (knock.socketId !== action.payload.socketId) return knock;
      return _objectSpread(_objectSpread({}, action.payload), {}, {
        accepted: action.type === _types.BROADCAST_ACCEPT_KNOCK
      });
    });
  }
  if (["".concat(_types.BROADCAST_UPDATE_KNOCK, "_SUCCESS"), "".concat(_types.BROADCAST_UPDATE_REQUEST, "_SUCCESS")].includes(action.type)) {
    return state.map(function (knock) {
      if (knock._id !== action.payload._id) return knock;
      return _objectSpread({}, action.payload);
    });
  }
  if (action.type === "".concat(_types.BROADCAST_GET_KNOCKS, "_SUCCESS")) {
    return _toConsumableArray(action.payload);
  }
  if (action.type === "".concat(_types.BROADCAST_APPROVE_ALL_KNOCKS, "_SUCCESS")) {
    return findAndUpdateKnocks(state, action.payload);
  }
  if (action.type === "".concat(_types.BROADCAST_SOURCE_TO_KNOCK)) {
    return state.map(function (knock) {
      return knock._id === action.payload._id ? action.payload : knock;
    });
  }
  if ([_types.BROADCAST_CLEAR_KNOCK, _types.BROADCAST_CANCEL_KNOCK_REQUESTS].includes(action.type)) {
    return state.filter(isSameKnockId(action.payload));
  }
  if (_types.BROADCAST_SET_DESIRED_KNOCK_AV_STATUS === action.type) {
    var currentKnockIndex = state.findIndex(function (knock) {
      return action.payload.id === knock._id;
    });
    var _ref = action.payload || {},
      isCameraOn = _ref.isCameraOn,
      isMicrophoneOn = _ref.isMicrophoneOn;
    if (currentKnockIndex > -1) {
      state[currentKnockIndex].isCameraOn = isCameraOn;
      state[currentKnockIndex].isMicrophoneOn = isMicrophoneOn;
    }
    return state;
  }
  return state;
}
function findAndUpdateKnocks(currentKnocks, updatedKnocks) {
  var updatedKnocksMap = (0, _underscore.indexBy)(updatedKnocks, '_id');
  return currentKnocks.map(function (knock) {
    return updatedKnocksMap[knock === null || knock === void 0 ? void 0 : knock._id] || knock;
  });
}